import { reactive, computed } from '@vue/composition-api';
import { useContext } from '@berlin-front/common/composables/context';
import { useRouter } from '@berlin-front/common/composables/useRouter';
import { ApiCacheContext } from '@/services/ApiCacheContext';
import { ROUTE_NAME } from '@/router/route-name';
import { useRoute } from '@berlin-front/common/composables/useRoute';
import { SplitPaymentContextType } from './context';

const SPLIT_MESSAGE_ABOUT_PAYMENT_TIMES = 'ご注文の確定後は、支払い回数を変更できません';
const SPLIT_MESSAGE_ABOUT_NP_POINT = '分割払いの場合、NPポイントの値引きはアプリからのみできます。';
const SPLIT_MESSAGE_ABOUT_SPLIT_REMAINDER = '端数がある場合は各回のお支払い金額が異なります';

export default {
  useSplitPayment: (): ReturnType<SplitPaymentContextType['useSplitPayment']> => {
    const router = useRouter();
    const route = useRoute();
    const { atoneMethodGetResult, userFullName } = useContext(ApiCacheContext);

    const { splitPattern } = route.query;
    const usablePatterns = atoneMethodGetResult.value?.splitPayment?.usablePatterns;
    const splitDetail = usablePatterns?.find((pattern) => pattern.splitTimes === splitPattern);

    // 商品合計金額
    const itemTotalAmount = computed(() => atoneMethodGetResult.value?.splitPayment?.amount ?? 0);
    // 支払い回数
    const splitTimes = computed(() => splitDetail?.splitAmounts.length ?? 0);
    // １回あたりの支払い金額（最後の支払い金額を使用する）
    const splitAmount = computed(() => splitDetail?.splitAmounts[splitTimes.value - 1].amount ?? 0);
    // 月々の支払い金額
    const amounts = computed(() => splitDetail?.splitAmounts ?? []);

    // 「ご注文を確定」押下時のアクション
    const onSubmit = () => {
      void router.replace({ name: ROUTE_NAME.ATONE_SPLIT_LOADING_SETTLEMENT, query: { splitPattern } });
    };

    // 「戻る」押下時のアクション
    const goBack = () => {
      void router.replace({ name: ROUTE_NAME.ATONE_SPLIT_SELECT });
    };

    return reactive({
      itemTotalAmount,
      splitAmount,
      splitTimes,
      amounts,
      splitMessages: [
        SPLIT_MESSAGE_ABOUT_PAYMENT_TIMES,
        SPLIT_MESSAGE_ABOUT_NP_POINT,
        SPLIT_MESSAGE_ABOUT_SPLIT_REMAINDER,
      ],
      memberName: userFullName,
      onSubmit,
      goBack,
    });
  },
};
